module.exports = __webpack_public_path__ + "media/src/images/logos/messenger-efc6a1f2900afd19ced9dc27d071f39e.png";